/** Narrowing guards with no runtime dependency on class-validator or similar. */
export function isNonEmptyString(value) {
    return typeof value === 'string' && value.trim().length > 0;
}
export function isRecord(value) {
    return typeof value === 'object' && value !== null && !Array.isArray(value);
}
/** Compile-time exhaustiveness helper. */
export function assertNever(value, context) {
    throw new Error(context === undefined
        ? `Unexpected value: ${String(value)}`
        : `${context}: unexpected value ${String(value)}`);
}
/** Trims and lowercases, the canonical form used for email lookups. */
export function normaliseEmail(value) {
    return value.trim().toLowerCase();
}
//# sourceMappingURL=guards.js.map